import { useId } from 'react';

import { useTranslation } from 'react-i18next';

export function BankPrimaryControl({
  automatic,
  checked,
  onSelect,
  name,
}: {
  automatic: boolean;
  checked: boolean;
  onSelect: () => void;
  name?: string;
}) {
  const id = useId();
  const { t } = useTranslation('admin');
  return (
    <div className="space-y-1">
      <label
        htmlFor={id}
        className="flex min-h-11 items-center gap-2 text-sm font-body text-slate-700"
      >
        <input
          id={id}
          type="radio"
          name={name ?? id}
          checked={automatic || checked}
          disabled={automatic}
          onChange={onSelect}
          className="size-4 border-slate-300 text-primary-500 focus:ring-primary-500"
        />
        {t('parties.form.primary')}
      </label>
      <p className="text-xs font-body text-slate-500">
        {t(automatic ? 'parties.form.primary_automatic' : 'parties.form.primary_choice_hint')}
      </p>
    </div>
  );
}
